import { useUser } from '@auth0/nextjs-auth0';
import { useEffect, useRef } from 'react';
import Head from 'next/head';
import Script from 'next/script';

const InitialValidations = (props) => {
  const { children } = props;
  const { user } = useUser();
  const checkUser = useRef();
  checkUser.current = () => {
    let root = document.getElementById('__next');
    if (user && root) {
      root.style.height = '100%';
    }
  };

  useEffect(() => {
    checkUser.current();
  }, [user]);

  const createUserId = () => {
    if (user) {
      return `gtag('set', {'user_id': "${`${user.sub}`}"})`;
    }
    return '';
  };
  return (
    <>
      <Script
        strategy='lazyOnload'
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_ANALYTICSCODE}`}
      />
      <Script strategy='lazyOnload' id='ga-code'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){
            dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_ANALYTICSCODE}', 
              {
                page_path: window.location.pathname + window.location.search,
              }
            );       
            ${createUserId()}   
            gtag('set', {'dimention1': ${(!!user).toString()}})
        `}
      </Script>
      <Head>
        <title>PolicyInfluence</title>
        <link rel='shortcut icon' href='/favicon.ico' />
        {process.env.NEXT_PUBLIC_ALLOW_INDEXING === 'false' && <meta name='robots' content='noindex, nofollow' />}
      </Head>
      {children}
    </>
  );
};

export default InitialValidations;
